#import "./meeting-validity-issue-fragment.graphql"

fragment MeetingStubFragment on Meeting {
    id
    modelId
    name
    meetingType
    htmlUrlPath
    durationMinutes
    activityType {
        id
        name
    }
    location
    locationType
    creator {
        id
        name
        firstName
    }
    cohosts {
        id
        name
    }
    hosts {
        id
        name
    }
    team {
        id
        name
    }
    bookings {
        id
    }
    publicMeetingLink
    isActive
    startTimeIntervalMinutes
    numViews
    bookingRate
    spansTimezones
    lastBookedTime
    validity {
        issues {
            ...MeetingValidityIssueFragment
        }
        isBookable
    }
    embedSnippet
    deletedTime
    allowAdditionalAttendees
    isHidden
    isShowable
    isHideable
    isManagedMeeting
}
